module.exports = __webpack_public_path__ + "static/img/fish42.5af3a3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish42.png
// module id = b0eh
// module chunks = 0